import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import bank_icon from "../../../assets/icons/bank_icon.png";
import { FormInput, FormSelect } from "../../inputs";
import { Radio, Typography, Popover } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { currencyMapper } from "../../../config/helper";
const { Text } = Typography;
export const p_types = [
  {
    label: "Within Bank",
    value: "WITHIN_BANK",
  },
  {
    label: "Domestic Transfers",
    value: "LOCAL_US_ACH",
  },
  {
    label: "International Wire (SWIFT)",
    value: "SWIFT_CROSSBORDER",
  },
];

const TransferModeOptions = ({ setValue }) => {
  const impsDescription = (
    <div>
      <Text>
        Instant transfer, available 24/7, with a limit on transaction amount.
      </Text>
    </div>
  );

  const neftDescription = (
    <div>
      <Text>
        Processed in batches during bank working hours, usually completed within
        a few hours.
      </Text>
    </div>
  );

  const rtgsDescription = (
    <div>
      <Text>
        Real-time processing for high-value transactions, available during
        banking hours.
      </Text>
    </div>
  );

  return (
    <Radio.Group
      defaultValue={"imps"}
      onChange={(e) => {
        setValue("mode_of_payment", e.target.value);
      }}
    >
      <div className="transfer-modes">
        <Radio value="imps" defaultChecked>
          IMPS
          <Popover
            content={impsDescription}
            title="IMPS (Immediate Payment Service)"
            trigger="hover"
          >
            <InfoCircleOutlined style={{ marginLeft: 15 }} />
          </Popover>
        </Radio>

        <Radio value="neft">
          NEFT
          <Popover
            content={neftDescription}
            title="NEFT (National Electronic Funds Transfer)"
            trigger="hover"
          >
            <InfoCircleOutlined style={{ marginLeft: 15 }} />
          </Popover>
        </Radio>

        <Radio value="rtgs">
          RTGS
          <Popover
            content={rtgsDescription}
            title="RTGS (Real-Time Gross Settlement)"
            trigger="hover"
          >
            <InfoCircleOutlined style={{ marginLeft: 15 }} />
          </Popover>
        </Radio>
      </div>
    </Radio.Group>
  );
};

const RecipientsForm = ({ next, setDBAcc, onSubmit: onSub, acc, mainData }) => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    control,
    formState: { errors },
    register,
    watch,
    setValue,
  } = useForm({
    defaultValues: {
      mode_of_payment: "imps",
    },
  });

  const [selectTo, setSelectTo] = useState("ben");

  const currenciesRes = useSelector((state) =>
    state?.currencies?.data?.data?.length
      ? state?.currencies?.data?.data?.map((ele) => ({
          label: (
            <span
              style={{
                color: "#212121",
                fontSize: 15,
              }}
            >
              <img
                src={`https://cdn.jsdelivr.net/npm/svg-country-flags@1.2.10/svg/${ele?.country_code?.toLowerCase()}.svg`}
                className="mr1"
                width={25}
                style={{
                  boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.4)",
                }}
              />
              {`${ele?.iso_code}`}
            </span>
          ),
          value: ele.id,
          iso_code: ele.iso_code,
          country_code: ele.country_code,
        }))
      : []
  );

  const BeneficiaryBankDetails = useSelector((state) =>
    state?.customers?.all?.data?.data?.map((ele) => ({
      ...ele,
      label:
        ele?.beneficiary_name + "-" + ele?.bank_accounts?.[0]?.account_number,
      value: ele?.bank_accounts?.[0]?.id,
    }))
  );

  const onSubmit = (data) => {
    console.log(data);

    onSub(data);
    next();
  };

  const addressObj = acc?.billing_addresses?.[0];
  const method = watch("method");

  React.useEffect(() => {
    if (mainData) {
      setValue("recipient", mainData?.recipient);
      setValue("method", mainData?.method);
      setValue("currency", mainData?.currency);
    }
  }, [mainData]);

  return (
    <form className=" ml3" onSubmit={handleSubmit(onSubmit)}>
      <div className="pp-form-item">
        <label style={{ color: "#3B3B3B" }}>To</label>
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            type="button"
            className={selectTo === "ben" ? "send-btn" : "back-btn"}
            onClick={() => {
              setSelectTo("ben");
            }}
          >
            Beneficiaries
          </button>
          <button
            type="button"
            className={selectTo === "own_ac" ? "send-btn" : "back-btn"}
            onClick={() => {
              setSelectTo("own_ac");
            }}
          >
            Own AC
          </button>
          <button
            type="button"
            className={selectTo === "acc_no" ? "send-btn" : "back-btn"}
            onClick={() => {
              setSelectTo("acc_no");
            }}
          >
            Account Number
          </button>
          <button
            type="button"
            className={selectTo === "upi" ? "send-btn" : "back-btn"}
            onClick={() => {
              setSelectTo("upi");
            }}
          >
            UPI
          </button>
          <button
            type="button"
            className={selectTo === "mobile" ? "send-btn" : "back-btn"}
            onClick={() => {
              setSelectTo("mobile");
            }}
          >
            Mobile Number
          </button>
        </div>
      </div>
      <div className="w40">
        {(selectTo === "ben" || selectTo === "own_ac") && (
          <div className="pp-form-item">
            <FormSelect
              inline
              label={selectTo === "own_ac" ? "Select To" : "Recipient"}
              control={control}
              options={BeneficiaryBankDetails}
              required={true}
              {...register("recipient", {
                required: "Please select the recipient.",
                onChange: (e) => {
                  const benAcc = BeneficiaryBankDetails?.find(
                    (ele) => ele?.bank_accounts?.[0]?.id === e.target.value
                  );
                  setDBAcc(
                    BeneficiaryBankDetails?.find(
                      (ele) => ele?.bank_accounts?.[0]?.id === e.target.value
                    )
                  );

                  setValue(
                    "method",
                    p_types?.find(
                      (ele) => ele.value === benAcc?.account_transfer_mode_type
                    )?.value
                  );
                  const curr = currenciesRes?.find(
                    (ele) => ele.country_code === benAcc?.country_code
                  );
                  setValue("currency", curr?.value);
                  setValue("iso_code", curr?.iso_code);
                },
              })}
              errors={errors}
              hideCreateOption={true}
            />
          </div>
        )}
        {(selectTo === "ben" || selectTo === "acc_no") && (
          <div className="pp-form-item">
            <FormSelect
              inline
              label={"Method"}
              control={control}
              required={true}
              options={p_types}
              {...register("method", {
                required: "Please select the method.",
              })}
              errors={errors}
              hideCreateOption={true}
            />
            {/* <p>1 business day</p> */}
          </div>
        )}

        {method?.includes("ACH") ? (
          <div className="pp-form-item">
            <label>
              Mode of payment
              <sup
                style={{
                  color: "red",
                  fontSize: "14px",
                  position: "relative",
                  top: "-1px",
                }}
              >
                *
              </sup>
            </label>
            <TransferModeOptions register={register} setValue={setValue} />
          </div>
        ) : null}
        {method?.includes("SWIFT") ? (
          <div className="pp-form-item">
            <FormSelect
              control={control}
              {...register("currency", {
                required: "Currency is required",
                onChange: (e) => {
                  const curr = currenciesRes?.find(
                    (ele) => ele.value === e.target.value
                  );
                  setValue("iso_code", curr?.iso_code);
                },
              })}
              placeholder="Select Currency"
              errors={errors}
              label={"Currency"}
              required={true}
              hideCreateOption
              options={currenciesRes}
              inline
              filterKey={"iso_code"}
            />
          </div>
        ) : null}

        {selectTo === "acc_no" && (
          <div className="acc_no">
            <h2 className="mt2">Account Details</h2>
            <div className="pp-form-item">
              <FormInput
                control={control}
                required={true}
                {...register("name", {
                  required: "Name is required.",
                })}
                errors={errors}
                label={"Name on Passbook"}
                placeholder={"Enter Name on Passbook"}
              />
            </div>
            <div className="pp-form-item">
              <FormInput
                control={control}
                required={true}
                {...register("account_number", {
                  required: "Account Number is required.",
                })}
                errors={errors}
                label={"Account Number"}
                placeholder={"Enter Account Number"}
              />
            </div>
            <div className="pp-form-item">
              <FormInput
                control={control}
                required={true}
                {...register("confirm_account_number", {
                  required: "Confirm Account Number is required.",
                })}
                errors={errors}
                label={"Confirm Account Number"}
                placeholder={"Confirm your Account Number"}
              />
            </div>
            <div className="pp-form-item">
              <FormSelect
                inline
                label={"Account Type"}
                control={control}
                options={[{ label: "Savings", value: "savings" }]}
                required={true}
                {...register("account_type", {
                  required: "Please select account type.",
                })}
                errors={errors}
                hideCreateOption={true}
                placeholder={"Select Account type."}
              />
            </div>
            <div className="pp-form-item">
              <FormInput
                control={control}
                required={true}
                {...register("ifsc_code", {
                  required: "IFSC Code is required.",
                })}
                errors={errors}
                label={"IFSC Code"}
                placeholder={"Enter IFSC Code"}
                suffix={"Don’t know IFSC code?"}
              />
            </div>
          </div>
        )}
        {selectTo === "upi" && (
          <div>
            <div className="pp-form-item">
              <FormInput
                control={control}
                required={true}
                {...register("ifsc_code", {
                  required: "IFSC Code is required.",
                })}
                errors={errors}
                label={"UPI ID"}
                placeholder={"Enter UPI ID"}
                suffix={"Verify VPA"}
              />
            </div>

            {/* <div className="pp-form-item">
              <FormInput
                prefix={currencyMapper["INR"] ?? "$"}
                control={control}
                required
                {...register("amount", {
                  pattern: {
                    value: /^[0-9.]+$/i,
                    message: `${t("amount_validation")}`,
                  },
                  required: `${t("amount_field") + " " + t("is_Requrired")}`,
                })}
                errors={errors}
                label={"Amount"}
                number={true}
                suffix={
                  <>
                    <span className="value">
                      <img
                        src={`https://cdn.jsdelivr.net/npm/svg-country-flags@1.2.10/svg/in.svg`}
                        className="mr1"
                        width={20}
                        style={{
                          boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.4)",
                        }}
                      />
                      {"INR"}
                    </span>
                  </>
                }
              />
            </div> */}
          </div>
        )}

        {selectTo === "mobile" && (
          <div>
            <div className="pp-form-item">
              <FormInput
                control={control}
                required={true}
                {...register("mobile_number", {
                  required: "Mobile number is required.",
                })}
                errors={errors}
                label={"Mobile Number"}
                placeholder={"Enter Mobile Number linked to account"}
              />
            </div>
          </div>
        )}
        {acc?.id ? (
          <div className="mt3">
            <label>Recipient Bank Details</label>
            <div className="bank-details">
              <div className="nickname">
                <span className="label">Nickname</span>
                <span className="value">{acc?.beneficiary_name}</span>
              </div>
              <div className="legal-name">
                <span className="label">Email</span>
                <span className="value">{acc?.email}</span>
              </div>
              <div className="bank-info">
                <div className="bank-name">
                  <img src={bank_icon} alt="Bank Icon" className="bank-icon" />
                </div>
                <div className="acc-details">
                  <span className="value">
                    {acc?.bank_accounts?.[0]?.branch}
                  </span>
                  <span className="account-details">
                    Account **{" "}
                    {acc?.bank_accounts?.[0]?.account_number?.slice(-4)} •
                    Routing **{" "}
                    {acc?.bank_accounts?.[0]?.routing_code?.slice(-4)}
                  </span>
                  <span className="account-details">{`${addressObj?.address}, ${addressObj?.city}, ${addressObj?.state}, ${addressObj?.zipcode}, ${addressObj?.country}`}</span>
                </div>
              </div>
            </div>
          </div>
        ) : null}
        <button type="submit" className="send-btn mt3">
          {"Next"}
        </button>
      </div>
    </form>
  );
};

export default RecipientsForm;
